module.exports = require("@swa-ui/vacations/src/useVacationsFormLogic/useVacationsFormLogic.module.scss");